import React, { useCallback, useEffect, useState } from 'react';
import {
  Modal,
  Form,
  Button,
  Row,
  Col,
  Space,
  Typography,
  Popover,
  Divider,
  Radio,
  Empty,
  Table,
  Spin,
  InputNumber,
  Checkbox,
} from 'antd';
import { FormLabel, message } from 'components/common';
import { InfoCircleOutlined } from '@ant-design/icons'
import {
  getPickOrderDetail,
  markUnPickOrder,
  markPickOrder,
  pickingOrder,
} from 'services/orders';
// import {pickingByOrder2} from 'services/smart';
// import { fetchWarehouseProductList } from 'services/inventory';
import { userProfiles } from 'utils/auth';
// import { fetchWarehouseLocationList } from 'services/warehouse';
import { ModalProps } from 'antd/lib/modal/Modal';
import ModalDialog from '../../../../components/common/ModalDialog';
import moment from 'moment';

interface CreateGroupTicketsProps extends ModalProps {
  onHide: () => void;
  onRefresh: () => void;
  orderInfo: Order;
}

const pickStatusKeyValue: { [key: string]: string } = {
  '0': 'Not Picked',
  '1': 'Picked',
  '2': 'Partially Picked',
};

// eslint-disable-next-line
export default (props: CreateGroupTicketsProps) => {
  const { onHide, orderInfo, onRefresh } = props;
  const shipFlowValue = userProfiles.getProfileSettingValue('ShipFlow');
  const [loading, setLoading] = useState(false);
  const [pickingLoading, setPickingLoading] = useState<boolean>(false);
  const [saving, setSaving] = useState(false);
  const [detail, setDetail] = useState<any[]>([]);
  const [pickLines, setPickLines] = useState<any[]>([]);
  // const [pickLocation, setPickLocation] = useState<any>();
  const [current, setCurrent] = useState<any>();
  const [inventoryList, setInventoryList] = useState<any>(undefined);
  const [isMatch, setIsMatch] = useState<boolean>(false);
  const [hasOver, setHasOver] = useState<boolean>(false);
  // const [isAllMatch, setIsAllMatch] = useState<boolean>(false);
  const [withoutAdjustment, setWithoutAdjustment] = useState<boolean>(
    shipFlowValue === 'ScanFlow' ? false : true
  );
  const adjustmentMode =
    shipFlowValue === 'ScanFlow' &&
    orderInfo.pickStatus !== 1 &&
    !withoutAdjustment;
  // const enableUOM = userProfiles.getProfileSettingValue("EnableUOM");
  const enableLOT = userProfiles.getProfileSettingValue('EnableLOT');
  // const [isFilter, setIsFilter] = useState(true)
  const [filterArr, setFilterArr] = useState<any>([]);

  const [form] = Form.useForm();

  // useEffect(()=>{
  //   const temp = detail.filter((i:any)=> i.orderQty > i.pickedQty + i.pickingQty)
  //   if(temp.length === 0 && detail.length > 0){
  //     setIsAllMatch(true)
  //   } else {
  //     setIsAllMatch(false)
  //   }
  // },[detail])

  const sortLocationByLot = useCallback(
    (location: any[], autoFillType: number) => {
      let tempLocation: any[] = [...location];
      const noLot = location.filter((i) => !i.lotNumber);
      const noExpirationDate = location.filter(
        (i) => i.lotNumber && !i.expirationDate
      );
      const noFirstInDate = location.filter(
        (i) => i.lotNumber && !i.firstInDate
      );
      // console.log('autoFillType', autoFillType)
      if (autoFillType === 2) {
        const temp1 = location
          .filter((i) => i.lotNumber && i.firstInDate)
          .sort((a: any, b: any) => {
            return moment(a.firstInDate) >= moment(b.firstInDate) ? 1 : -1;
          });
        tempLocation = [...temp1, ...noFirstInDate, ...noLot];
      }
      if (autoFillType === 3) {
        const temp2 = location
          .filter((i) => i.lotNumber && i.expirationDate)
          .sort((a: any, b: any) => {
            return moment(a.expirationDate) >= moment(b.expirationDate)
              ? 1
              : -1;
          });
        tempLocation = [...temp2, ...noExpirationDate, ...noLot];
      }
      // console.log(templocation)
      return tempLocation;
    },
    []
  );

  const handleAdjustment = useCallback(
    (e: any, record: any) => {
      try {
        const { pickingQty, locationNum, lotNumber } = record;
        //const diff = e - pickingQty;
        const diff = pickingQty - e;
        const inventoryListTemp = JSON.parse(JSON.stringify(inventoryList));
        const skuTemp = inventoryListTemp[current.fulfillmentOrderLineNum];
        // let { fromList = [], toList = [] } = skuTemp;
        let fromList = skuTemp?.fromList || [];
        let toList = skuTemp?.toList || [];
        //console.log('d', e, pickingQty, diff);

        const arr1: any[] = [];
        fromList.forEach((item: any) => {
          if (item.locationNum === locationNum && item.lotNumber === lotNumber) {
            arr1.push({
              ...item,
              pickingQty: e,
              //totalQty: item.quantity + e,
              totalQty: item.quantity - e,
            });
          } else {
            arr1.push(item);
          }
        });
        const tempArr2 = [...toList];
        const index = toList.findIndex((i: any) => i.lotNumber === lotNumber);
        //console.log('gt -1', index, tempArr2, record);
        if (index > -1) {
          tempArr2[index] = {
            ...tempArr2[index],
            pickingQty: tempArr2[index].pickingQty - diff,
            totalQty: tempArr2[index].totalQty - diff,
          };
        } else {
          tempArr2.push({
            ...toList[0],
            lotNumber: lotNumber,
            pickingQty: 0 - diff,
            totalQty: 0 - diff,
          });
        }
        //console.log('->', diff, tempArr2);

        // toList.forEach((item: any) => {
        //   if (item.lotNumber === lotNumber) {
        //     arr2.push({
        //       ...item,
        //       pickingQty: toList[0].pickingQty - diff,
        //       totalQty: toList[0].totalQty - diff
        //     })
        //   }
        // })

        // arr2.push({
        //   ...toList[0],
        //   pickingQty: toList[0].pickingQty - diff,
        //   totalQty: toList[0].totalQty - diff
        // })

        inventoryListTemp[current.fulfillmentOrderLineNum] = {
          fromList: arr1,
          toList: tempArr2,
        };
        setInventoryList(inventoryListTemp);
      } catch (error) {
        console.log(error);
      }
    },
    [inventoryList, current]
  );

  const columns = [
    {
      title: 'SKU',
      dataIndex: 'sku',
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      key: 1,
    },
    {
      title: 'UOM',
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      key: 1,
    },
    {
      title: 'Rate',
      dataIndex: 'uomRate',
      onCell: () => ({style: {textAlign: 'right' as 'right'}}),
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      key: 1,
    },
    {
      title: 'Ordered',
      dataIndex: 'orderQty',
      onCell: () => ({style: {textAlign: 'right' as 'right'}}),
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      key: 2,
    },
    {
      title: 'Picked',
      dataIndex: 'pickedQty',
      onCell: () => ({style: {textAlign: 'right' as 'right'}}),
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      key: 3,
    },
    {
      title: 'Picking',
      dataIndex: 'pickingQty',
      onCell: () => ({style: {textAlign: 'right' as 'right'}}),
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      key: 4,
      render: (_: number, record: any) => {
        if (inventoryList) {
          let sum = 0;
          const fromList =
            inventoryList[record.fulfillmentOrderLineNum]?.fromList || [];
          fromList.forEach((item: any) => {
            //sum -= item.pickingQty;
            sum += item.pickingQty;
          });
          return sum;
        } else {
          return 0;
        }
      },
    },
    {
      title: 'Option',
      dataIndex: 'option',
      onCell: () => ({style: {textAlign: 'center' as 'center'}}),
      onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
      key: 5,
      render: (_: number, record: any) => {
        return (
          <Radio
            disabled={record.pickedQty === record.orderQty}
            checked={record.isChecked}
          />
        );
      },
    },
  ];

  const getCurrentLine = () => {
    if (current && typeof current === 'object') {
      const lines = pickLines.filter(l => l && typeof l === 'object' && l.fulfillmentOrderLineNum === current.fulfillmentOrderLineNum);

      return lines[0] || null;
    }

    return null;
  };

  // eslint-disable-next-line
  const isLotUsable = () => {
    const line = getCurrentLine();
    const lotControl = line ? line.lotControl : undefined;
    //console.log('c->', lotControl);
    return enableLOT && lotControl === 1;
  };

  const pickingFromColumns = useCallback(() => {
    const lotUsable = isLotUsable();

    return [
      {
        //title: enableLOT ? 'Location [LOT#] (qty)' : 'Location (qty)',
        title: lotUsable ? 'Location [LOT#] (qty)' : 'Location (qty)',
        dataIndex: 'locationCode',
        // @ts-ignore
        onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
        key: 1,
        width: 400,
        render: (_: number, record: any) => {
          //console.log('r', record);
          return lotUsable ? (
            record.lotNumber ? (
              <Popover
                placement="topLeft"
                trigger="click"
                content={
                  <Space size="small" direction="vertical">
                    <Typography.Text>
                      first In Date:{' '}
                      {record.firstInDate
                        ? moment(record.firstInDate).format('MM/DD/YYYY')
                        : ''}
                    </Typography.Text>
                    <Typography.Text>
                      expiration Date:{' '}
                      {record.expirationDate
                        ? moment(record.expirationDate).format('MM/DD/YYYY')
                        : ''}
                    </Typography.Text>
                  </Space>
                }
              >
                <Space><Typography.Link style={{color: 'rgba(0, 0, 0, 0.85)'}}>{`${record.locationCode} [${record.lotNumber}] (${record.quantity})`}</Typography.Link><Typography.Link><InfoCircleOutlined /></Typography.Link></Space>
              </Popover>
            ) : (
              `${record.locationCode} (${record.quantity})`
            )
          ) : (
            `${record.locationCode} (${record.quantity})`
          );
        },
      },
      {
        title: 'Picking',
        dataIndex: 'pickingQty',
        // @ts-ignore
        onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
        // @ts-ignore
        onCell: () => ({style: {textAlign: 'right' as 'right'}}),
        width: 150,
        key: 2,
        render: (_: number, record: any) => {
          return (
            <InputNumber
              type="number"
              //max={0}
              max={record.quantity}
              min={0}
              //min={0 - record.quantity}
              step={1}
              value={record.pickingQty}
              style={{ width: '100%' }}
              onChange={(e) => handleAdjustment(e, record)}
            />
          );
        },
      },
      {
        title: 'Total',
        dataIndex: 'totalQty',
        onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
        onCell: () => ({style: {textAlign: 'right' as 'right'}}),
        key: 3,
      },
    ];
  }, [isLotUsable, handleAdjustment]);

  const pickingToColumns = () => {
    const lotUsable = isLotUsable();

    return [
      {
        title: lotUsable ? 'Location [LOT#] (qty)' : 'Location (qty)',
        dataIndex: 'locationCode',
        onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
        width: 400,
        key: 1,
        render: (_: number, record: any) => {
          return lotUsable
            ? `${record.locationCode} [${record.lotNumber}] (${record.quantity})`
            : `${record.locationCode} (${record.quantity})`;
        },
      },
      {
        title: 'Picking',
        dataIndex: 'pickingQty',
        onCell: () => ({style: {textAlign: 'right' as 'right'}}),
        onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
        width: 150,
        key: 2,
      },
      {
        title: 'Total',
        dataIndex: 'totalQty',
        onCell: () => ({style: {textAlign: 'right' as 'right'}}),
        onHeaderCell: () => ({style: {textAlign: 'center' as 'center'}}),
        key: 3,
      },
    ];
  };

  const handelMarkUnpick = useCallback(async () => {
    try {
      setSaving(true);
      const res = await markUnPickOrder(orderInfo.fulfillmentOrderNum);
      setSaving(false);
      if (res.isSuccess) {
        message.success('Mark as Not Picked successfully');
        onRefresh();
      }
    } catch (error) {
      setSaving(false);
    }
  }, [onRefresh, orderInfo]);

  const onClickLine = (row: StringKAnyVPair, index: number) => {
    if (row.pickedQty === row.orderQty) return;
    if (row.isChecked) {
      setCurrent(row);
      return;
    }

    const obj = { ...row, isChecked: true };
    setCurrent(obj);
    detail.length > 0 && setDetail(
      detail.map((item, idx) => {
        if (idx === index) return obj;

        return {
          ...item,
          isChecked: false,
        };
      })
    );
    //console.log('i', inventoryList);
  };

  // const onClickMarkPick = async () => {
  //   setLoading(true);
  //   if (adjustmentMode && isMatch) {
  //     await handelMarkpick();
  //     Promise.all(moveProductFromLocationA2B());
  //     // await Promise.all(handlePickItemBySKU());
  //   } else {
  //     handelMarkpick();
  //   }
  //   setLoading(false);
  // }

  const moveProductFromLocationA2B = useCallback(async () => {
    const params: any[] = [];
    try {
      for (const key in inventoryList) {
        if (Object.prototype.hasOwnProperty.call(inventoryList, key)) {
          const { fromList = [] } = inventoryList[key];
          fromList.forEach((item: any) => {
            if (Math.abs(item.pickingQty) > 0) {
              const queryParams = {
                FulfillmentOrderNum: orderInfo.fulfillmentOrderNum,
                LocationCode: item.locationCode,
                FulfillmentOrderLineNum: item.fulfillmentOrderLineNum,
                Title: item.title,
                SkuOrUpc: item.sku,
                PickQty: item.pickQty,
                PickedQty: Math.abs(item.pickingQty),
                FulfillmentProductNum: item.fulfillmentProductNum,
                LotNumber: item.lotNumber,
                UOM: item.uom,
                UomRate: item.uomRate,
              };
              params.push(queryParams);
            }
          });
        }
      }
      if (params.length === 0) {
        message.info('There is no data to save.');
        return;
      }
      setLoading(true);
      // console.log(params)
      const res = await pickingOrder(orderInfo.fulfillmentOrderNum, params);
      setLoading(false);
      if (res.isSuccess) {
        message.success('Save successfully');
        onRefresh();
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }, [inventoryList, onRefresh, orderInfo]);

  // const handlePickItemBySKU = () => {
  //   const apiList: Promise<any>[] = []
  //   try {
  //     for (const key in inventoryList) {
  //       if (Object.prototype.hasOwnProperty.call(inventoryList, key)) {
  //         const { fromList = [] } = inventoryList[key];
  //         fromList.forEach((item: any) => {
  //           const queryParams = {
  //             PickListNum: orderInfo.pickListNum,
  //             LocationCode: item.locationCode,
  //             SKU: item.sku,
  //             PickedQty: Math.abs(item.pickingQty)
  //           }
  //           if (Math.abs(item.pickingQty) > 0) {
  //             apiList.push(pickingItemBySKU(queryParams));
  //           }
  //         });
  //       }
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     return apiList;
  //   }
  // }

  const handelMarkpick = useCallback(async () => {
    try {
      setSaving(true);
      const res = await markPickOrder(orderInfo.fulfillmentOrderNum);
      setSaving(false);
      if (res.isSuccess) {
        message.success('Mark as Picked successfully');
        onRefresh();
      }
    } catch (error) {
      setSaving(false);
    }
  }, [onRefresh, orderInfo]);

  const handleCancel = () => {
    const cancel = form.isFieldsTouched();
    if (!cancel) {
      onHide();
    } else {
      Modal.confirm({
        title: 'Leave / Refresh Page?',
        okText: 'Leave',
        cancelText: 'Cancel',
        content: `Changes you made may not be saved.`,
        onOk() {
          onHide();
        },
      });
    }
  };

  const loadDetail = async () => {
    setLoading(true);
    try {
      const { data = {} } = await getPickOrderDetail(
        orderInfo.fulfillmentOrderNum
      );
      if (Array.isArray(data.order.orderLineList)) {
        const temp: { [keyL: string]: any } = {};
        const tempList = data.order.orderLineList.filter(
          (i: any) => i.pickedQty < i.orderQty
        );
        const tempFilterList = data.order.orderLineList.filter(
          (i: any) => i.pickedQty === i.orderQty
        );
        setPickLines(data.pickLines);
        setDetail(
          tempList.map((item: any) => {
            temp[item.fulfillmentOrderLineNum] = { fromList: [], toList: [] };
            return {
              ...item,
              isChecked: false,
            };
          })
        );
        setInventoryList(temp);
        setFilterArr(
          tempFilterList.map((i: any) => {
            return { ...i, isChecked: false };
          })
        );

        if (tempList.length === 1) {
          onClickLine(tempList[0], 0);
          tempList[0].isChecked = true;
          setDetail([...tempList]);
        }
      }
    } catch (e) {
      console.log('e = ', e);
    } finally {
      setLoading(false);
    }
  };
  const filterList = useCallback(
    (bl: boolean) => {
      const tempArr = bl
        ? detail.filter((i: any) => i.pickedQty < i.orderQty)
        : [...detail, ...filterArr];
      const tempFilterArr = bl
        ? detail.filter((i: any) => i.pickedQty === i.orderQty)
        : [];
      setDetail(tempArr);
      setFilterArr(tempFilterArr);
    },
    [detail, filterArr]
  );

  // useEffect(()=>{
  //   if(isFilter){
  //     filterList(isFilter)
  //   }
  // },[isFilter, filterList])

  const getInventory = async (product: any) => {
    // console.log('current',current)
    setPickingLoading(true);
    try {
      let data: any = [];
      const t = pickLines.filter(
        (i) => i.fulfillmentOrderLineNum === product.fulfillmentOrderLineNum
      );
      if (t.length > 0) {
        data = sortLocationByLot(t[0].locations, t[0].autoFillType);
      }
      let temp = { ...inventoryList };
      // fromList part
      const arr: any = [];
      const arr2: any = [];
      data
        .filter((i: any) => i.locationCode !== 'Pick' && i.quantity > 0)
        .forEach((item: any) => {
          //console.log('item', item, t);
          // if (!['Pick', 'PickMissing','Checkout'].includes(item.locationCode) && item.quantity > 0) {
          arr.push({
            quantity: item.quantity,
            locationCode: item.locationCode,
            locationId: item.locationId,
            locationNum: item.locationNum,
            sku: item.sku,
            lotNumber: item.lotNumber || '',
            lotControl: 'lotControl' in item ? item.lotControl : undefined,
            fulfillmentOrderLineNum: current.fulfillmentOrderLineNum,
            fulfillmentProductNum: current.fulfillmentProductNum,
            pickingQty: 0,
            //pickingQty: item.pickingQty,
            totalQty: item.quantity,
            uom: product.uom || 'EA',
            uomRate: product.uomRate || 1,
            pickQty: current.orderQty,
            title: item.productTitle,
            firstInDate: item.firstInDate,
            expirationDate: item.expirationDate,
          });
          // }
        });
      temp[product.fulfillmentOrderLineNum].fromList = arr;

      // toList part
      const target = data.filter((item: any) => item.locationCode === 'Pick');
      if (target.length > 0) {
        target.map((i: any) => {
          arr2.push({
            quantity: i.quantity,
            locationCode: i.locationCode,
            locationId: i.locationId,
            locationNum: i.locationNum,
            sku: i.sku,
            lotNumber: i.lotNumber || '',
            fulfillmentOrderLineNum: current.fulfillmentOrderLineNum,
            fulfillmentProductNum: current.fulfillmentProductNum,
            pickingQty: 0,
            totalQty: i.quantity,
          });
          return true;
        });
      } else {
        arr2.push({
          quantity: 0,
          locationCode: 'Pick',
          sku: current.sku,
          lotNumber: '',
          fulfillmentOrderLineNum: current.fulfillmentOrderLineNum,
          fulfillmentProductNum: current.fulfillmentProductNum,
          pickingQty: 0,
          totalQty: 0,
        });
      }
      temp[product.fulfillmentOrderLineNum].toList = arr2;

      if (detail.length === 1) {
        const ld = detail[0];
        const inv = temp[ld.fulfillmentOrderLineNum];

       if (inv) {
          const { fromList, toList } = inv;
          console.log('tl len', detail.length, ld, 'ds', inv);
          if (Array.isArray(fromList) && Array.isArray(toList) && fromList.length === 1 && toList.length === 1) {
            const pQty = ld.orderQty - ld.pickedQty;

            if (pQty > 0 && fromList[0].totalQty >= pQty) {
              fromList[0].pickingQty += pQty;
              fromList[0].totalQty -= pQty;
              toList[0].pickingQty += pQty;
              toList[0].totalQty += pQty;
              console.log('qty', ld);
            }
          }
        }
      }
      setInventoryList(temp);
      //console.log('si', temp);
    } catch (error) {
      console.log(error);
    } finally {
      setPickingLoading(false);
    }
  };

  // const getPickLocationInfo = async () => {
  //   try {
  //     const { databaseNum, warehouseNum } = orderInfo;
  //     const warehouseId = `${databaseNum}-${warehouseNum}`;
  //     const res = await fetchWarehouseLocationList(
  //       warehouseId,
  //       true,
  //       'Pick',
  //       0
  //     );
  //     setPickLocation(res[0]);
  //   } catch (error) { }
  // }

  /* eslint-disable */
  useEffect(() => {
    if (orderInfo && orderInfo.warehouseNum && orderInfo.fulfillmentOrderNum) {
      loadDetail();
      // getPickLocationInfo();
    }
  }, [orderInfo]);

  useEffect(() => {
    if (current) {
      getInventory(current);
    }
  }, [current]);

  useEffect(() => {
    let isMatch = true;
    let hasOver = false;
    const newDetails = detail.map((item) => {
      let sum = 0;
      // console.log('inventoryList', inventoryList)
      if (inventoryList && inventoryList[item.fulfillmentOrderLineNum]) {
        const fromList =
          inventoryList[item.fulfillmentOrderLineNum].fromList || [];
        fromList.forEach((item: any) => {
          //sum -= item.pickingQty;
          sum += item.pickingQty;
        });
      }
      //console.log('->', item.orderQty, item.pickingQty, sum);
      if (item.orderQty !== item.pickedQty + sum) isMatch = false;
      if (item.orderQty < item.pickedQty + sum) hasOver = true;
      return {
        ...item,
        pickingQty: sum,
      };
    });
    // console.log(newDetails)
    setDetail(newDetails);
    setIsMatch(isMatch);
    setHasOver(hasOver);
  }, [inventoryList]);

  const layout = {
    labelCol: { span: 12 },
    wrapperCol: { span: 12 },
  };
  return (
    <ModalDialog
      centered
      fullscreen={true}
      title="Change Pick Status"
      maskClosable={false}
      closeButton={true}
      closable={false}
      visible={true}
      bodyHeight={630}
      onClose={handleCancel}
      destroyOnClose={true}
      getContainer={false}
      footer={
        <Row justify="end">
          <Space>
            {orderInfo.pickStatus !== 1 && shipFlowValue === 'ScanFlow' && (
              <Checkbox
                checked={withoutAdjustment}
                onChange={(e) => {
                  if (e.target.checked) {
                    Modal.confirm({
                      title: `Are you sure you want to proceed?`,
                      content: `Further processing will be blocked if no sufficient quantity can be found in the "Pick" location.'`,
                      onOk() {
                        setWithoutAdjustment(e.target.checked);
                      },
                    });
                  } else {
                    setWithoutAdjustment(e.target.checked);
                  }
                }}
              >
                Continue without any inventory adjustment
              </Checkbox>
            )}
            {orderInfo.pickStatus === 1 && (
              <Button
                loading={saving}
                type="primary"
                disabled={loading}
                onClick={() => {
                  handelMarkUnpick();
                }}
              >
                Mark as Not Picked
              </Button>
            )}
            {orderInfo.pickStatus !== 1 && withoutAdjustment && (
              <Button
                loading={saving}
                disabled={loading}
                type="primary"
                onClick={() => {
                  handelMarkpick();
                }}
              >
                Mark as Picked
              </Button>
            )}
            {orderInfo.pickStatus !== 1 && !withoutAdjustment && (
              <Button
                loading={saving}
                disabled={loading || hasOver}
                type="primary"
                onClick={() => {
                  moveProductFromLocationA2B();
                }}
              >
                {isMatch ? 'Mark as Picked' : 'Save Adjustment'}
              </Button>
            )}
          </Space>
        </Row>
      }
    >
      {/* <Modal
      title="Change Pick Status"
      centered
      visible={visible}
      maskClosable={false}
      width={800}
      bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
      destroyOnClose={true}
      onCancel={handleCancel}
      getContainer={false}
      footer={
        <Row justify="end">
          <Space>
            {orderInfo.pickStatus !== 1 && shipFlowValue === 'ScanFlow' && <Checkbox
              checked={withoutAdjustment}
              onChange={e => setWithoutAdjustment(e.target.checked)}
            >
              Continue without any inventory adjustment
            </Checkbox>}
            {orderInfo.pickStatus === 1 && <Button
              loading={saving}
              type="primary"
              disabled={loading}
              onClick={() => {
                handelMarkUnpick();
              }}
            >
              Mark as Not Picked
            </Button>}
            {orderInfo.pickStatus !== 1 && <Button
              loading={saving}
              disabled={loading || (!withoutAdjustment && !isMatch)}
              type="primary"
              onClick={() => {
                onClickMarkPick();
              }}
            >
              Mark as Picked
            </Button>}
          </Space>
        </Row>
      }
    > */}
      <Spin spinning={loading}>
        <Row>
          <Col span={12}>
            <Form.Item
              {...layout}
              label={<FormLabel>Channel Order Id</FormLabel>}
            >
              <Typography.Text>{orderInfo.channelOrderId}</Typography.Text>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label={<FormLabel>Pick Status</FormLabel>}>
              <Typography.Text>
                {pickStatusKeyValue[orderInfo.pickStatus]}
              </Typography.Text>
            </Form.Item>
          </Col>
        </Row>
        {adjustmentMode && (
          <Spin spinning={pickingLoading}>
            <Divider style={{ margin: '8px 0px' }} />
            <Checkbox
              defaultChecked
              onChange={(e) => filterList(e.target.checked)}
            >
              hide picked item
            </Checkbox>
            <div style={{ maxHeight: 150, overflow: 'auto' }}>
              <Table
                bordered
                columns={columns}
                showSorterTooltip={false}
                rowKey={(record: any) => record.fulfillmentOrderLineNum}
                rowClassName={(record) => {
                  return record.orderQty ===
                    record.pickedQty + record.pickingQty
                    ? 'match-row'
                    : '';
                }}
                dataSource={detail}
                // pagination={detail.length > 5 ? { position: ['bottomRight'] } : false}
                pagination={false}
                onRow={(row, index) => {
                  return {
                    onClick: () => onClickLine(row, index as any),
                  };
                }}
              />
            </div>
            {current &&
              (inventoryList[current.fulfillmentOrderLineNum]?.fromList || [])
                .length > 0 && (
                <>
                  <Divider
                    style={{ margin: '8px 0px' }}
                  >{`Picking: ${current.sku}`}</Divider>
                  <Typography.Title level={5}>From</Typography.Title>
                  <div style={{ overflow: 'auto' }}>
                    <Table
                      bordered
                      columns={pickingFromColumns()}
                      showSorterTooltip={false}
                      rowKey={(record) =>
                        `${record.locationNum}---${record.lotNumber}`
                      }
                      dataSource={
                        inventoryList[current.fulfillmentOrderLineNum]
                          ?.fromList || []
                      }
                      scroll={
                        (
                          inventoryList[current.fulfillmentOrderLineNum]
                            ?.fromList || []
                        ).length > 4
                          ? { y: 150 }
                          : undefined
                      }
                      // pagination={detail.length > 10 ? { position: ['bottomRight'] } : false}
                      pagination={false}
                    />
                  </div>
                  <Typography.Title level={5}>To</Typography.Title>
                  <div style={{ maxHeight: 150, overflow: 'auto' }}>
                    <Table
                      bordered
                      columns={pickingToColumns()}
                      showSorterTooltip={false}
                      rowKey={(record) =>
                        `${record.locationNum}---${record.lotNumber}`
                      }
                      dataSource={
                        inventoryList[current.fulfillmentOrderLineNum]
                          ?.toList || []
                      }
                      // pagination={detail.length > 10 ? { position: ['bottomRight'] } : false}
                      pagination={false}
                    />
                  </div>
                </>
              )}
            {current &&
              (inventoryList[current.fulfillmentOrderLineNum]?.fromList || [])
                .length === 0 && (
                <Empty
                  style={{ marginTop: 8 }}
                  description={`No in-stock can be found for ${current.sku} in [${orderInfo.warehouseCode}]`}
                />
              )}
          </Spin>
        )}
      </Spin>
      {/* </Modal> */}
    </ModalDialog>
  );
};
